import { render } from "./DialogBoxComponent.vue?vue&type=template&id=668203e1"
import script from "./DialogBoxComponent.vue?vue&type=script&lang=js"
export * from "./DialogBoxComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__